import DadosFinanceirosAbertas from "./DadosFinanceirosAbertas";
import DadosFinanceirosRecebidos from "./DadosFinanceirosRecebidos";
import { useUserInfor } from "../../../Context/User";
import ParcelasSerasa from "./ParcelasSerasa";
import { Tab, Tabs } from "react-bootstrap";

interface IDadosFinanceirosProps {
    ID_CHAVE_ERP: string;
}

export default function DadosFinanceiros(props: IDadosFinanceirosProps) {
    const { OrgInfor } = useUserInfor();

    const uauMode = OrgInfor.COD_ERP_INTEGRACAO === "UAU";

    return (
        <div>
            <Tabs mountOnEnter defaultActiveKey={"receber"}>
                <Tab title="A Receber" eventKey="receber">
                    <DadosFinanceirosAbertas
                        ID_CHAVE_ERP={props.ID_CHAVE_ERP}
                    />
                </Tab>

                <Tab title="Recebidos" eventKey="recebidos">
                    <DadosFinanceirosRecebidos
                        ID_CHAVE_ERP={props.ID_CHAVE_ERP}
                    />
                </Tab>

                {uauMode && (
                    <Tab title="Parcelas Serasa" eventKey="parcelaSerasa">
                        <ParcelasSerasa ID_CHAVE_ERP={props.ID_CHAVE_ERP} />
                    </Tab>
                )}
            </Tabs>
        </div>
    );
}
